import React from 'react';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary via-steel-blue to-innovation-blue text-white py-20 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-32 h-32 border border-white/20 rounded-full"></div>
        <div className="absolute top-40 right-20 w-24 h-24 border border-white/20 rounded-full"></div>
        <div className="absolute bottom-20 left-1/4 w-16 h-16 border border-white/20 rounded-full"></div>
        <div className="absolute bottom-40 right-1/3 w-20 h-20 border border-white/20 rounded-full"></div>
      </div>

      <div className="relative max-w-6xl mx-auto px-6 lg:px-8">
        <div className="space-y-8 text-center">
          <div className="flex items-center justify-center space-x-3">
            <div className="flex items-center justify-center w-12 h-12 bg-white/20 rounded-lg backdrop-blur-sm">
              <Icon name="Building" size={24} color="white" strokeWidth={2} />
            </div>
            <span className="text-lg font-medium text-white/90">About Mirakalous Technologies Inc.</span>
          </div>

          <h1 className="text-5xl lg:text-6xl font-bold leading-tight">
            Practical, production‑grade AI for regulated and high‑stake environments
          </h1>

          <p className="text-2xl text-white/90 leading-relaxed max-w-4xl mx-auto">
            We specialize in on‑prem and private‑cloud deployments where data sovereignty, safety, and auditability matter as much as accuracy and speed.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;